import React, { useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import { MDBDataTable } from 'mdbreact';
import 'mdbreact/dist/css/mdb.css';
import Api from '../function/axiosInterceptor';
import Moment from 'react-moment';
import 'moment-timezone';
import { Button, Dropdown, Space } from 'antd';
import { Link } from 'react-router-dom';
import { BiEdit } from 'react-icons/bi';
import { AiFillDelete } from 'react-icons/ai';
import { AiOutlineTool } from 'react-icons/ai';
import { toast } from 'react-toastify';
const Pagelist = () => {
    const [page, getpages] = useState([]);
    const toast_alert = (sms, status) => {
        if (status == 0) {
            toast.success(sms, {
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(sms, {
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }
    const getPage = async () => {
        try {
            const response = await Api.get("/admin/pagalist");
            if (response.status == 1) {
                getpages(response.data);
            }
        } catch (err) {

        }
    }
    const Deletepage = async (e) => {
        try {
            const response = await Api.get("/admin/del", { params: { sno: e.target.id } });
            if (response.status == 'success') {
                toast_alert('Menu Succussfully deleted.', 0);
                getPage();
            } else {
                toast_alert(response.message);
            }
        } catch (err) {

        }
    }
    const data = {
        columns: [
            {
                label: '#',
                field: 'sno',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Title',
                field: 'title',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Routes',
                field: 'routes',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Status',
                field: 'status',
                sort: 'asc',
                width: 270
            },
            {
                label: 'Last Modified',
                field: 'last',
                sort: 'asc',
                width: 200
            }
            ,
            {
                label: 'Action',
                field: 'action',
                sort: 'asc',
                width: 200
            }
        ],
        rows: []
    };
    useEffect(() => {
        getPage();
    }, []);
    page && page.map((inf, i) => {
        const items = [
            {
                key: '1',
                label: (
                    <Link rel="noopener noreferrer" to={"page-edit/" + page[i].sno}><BiEdit /> Edit</Link>
                ),
            },
            {
                key: '2',
                label: (
                    <Link rel="noopener noreferrer" id={page[i].sno} onClick={Deletepage}><AiFillDelete /> Delete</Link>
                ),
            },
        ];
        data.rows.push({
            sno: i + 1,
            title: page[i].title,
            routes: page[i].route,
            status: page[i].status == 1 ? 'Active' : 'Inactive',
            last: <Moment format="DD/MMMM/YYYY">{page[i].date}</Moment>,
            action: <Space direction="vertical">
                <Space wrap>
                    <Dropdown
                        menu={{
                            items,
                        }}
                        placement="bottom"
                    >
                        <Button><AiOutlineTool /> Action</Button>
                    </Dropdown>
                </Space>
            </Space>
        })
    })

    return (
        <>
            <Card>
                <Card.Header>Page List</Card.Header>
                <Card.Body>
                    <div className='d-flex justify-content-between'>
                        <div className=''>
                            <p className="text-muted mb-3">Total Page :<code>{page.length < 10 ? '0' + page.length : page.length}</code></p>
                        </div>
                        <div>
                            <Link to="/admin/newpage"><button className='custom-btn'> Add New</button></Link>
                        </div>
                    </div>

                    <MDBDataTable
                        striped
                        bordered
                        small
                        data={data}
                    />
                </Card.Body>
            </Card>
        </>
    );
}

export default Pagelist;